import GridColumnProps from './Columns'
import Vue from 'vue'

let KendoGridColumn = {
    name: 'kendo-grid-column',
    render () {
        return Vue.prototype._e
    },
    mixins: [GridColumnProps]
}

export default KendoGridColumn


// WEBPACK FOOTER //
// ./packages/kendo-grid-vue-wrapper/src/KendoGridColumn/index.js